<template>
  <v-footer dark height="auto" v-if="['homePage', 'home', 'logIn', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">
    <v-card class="indigo lighten-1 flex" flat tile>
      <!-- <v-card-title class=" blue darken-4">
        <strong class="subheading">Get connected with us on social networks!</strong>
        <v-spacer></v-spacer>
        <v-btn v-for="icon in icons" :key="icon" class="mx-3" dark icon>
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-title> -->
      <v-card-actions class="blue darken-4 justify-center">
        &copy;2018 — <strong> Naics Furnishing Co., Ltd.</strong>
      </v-card-actions>
    </v-card>
  </v-footer>

  <v-footer class=" blue darken-4" dark height="auto" v-else>
    <v-layout column wrap>
      <v-flex xs12>
        <v-container grid-list-xl>
          <v-layout row wrap class="my-0">
            <v-flex xs12 sm3>
              <v-layout column wrap>
                <v-flex xs12>
                  <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div class="text-xs-center" style="font-size:26px">ลิ้งค์สำคัญ</div>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="font-size:15px">
                      <v-layout row wrap style="font-size:20px">
                        <v-flex xs12 md6>
                          <v-btn outline color="white" :to="{ name: 'homePage'}">Home</v-btn>
                          <!-- <a href="/home" class="white--text" style="text-decoration:none">Home</a> -->
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-btn outline color="white" :to="{ name: 'product'}">Product</v-btn>
                          <!-- <a class="white--text" style="text-decoration:none" href="/product">Product</a> -->
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-btn outline color="white" :to="{ name: 'aboutUs'}">About Us</v-btn>
                          <!-- <a class="white--text" style="text-decoration:none" href="/about-us">About Us</a> -->
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-btn outline color="white" :to="{ name: 'contactUs'}">Contact Us</v-btn>
                          <!-- <a class="white--text" style="text-decoration:none" href="/contact-us">Contact Us</a> -->
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div class="text-xs-center" style="font-size:26px">บริษัทในเครือ</div>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6>
                          <a href="/home">
                            <v-img
                              :src="require('@/assets/logo.png')"
                              :lazy-src="require('@/assets/logo.png')"
                              max-height="120"
                              max-width="120"
                              contain
                              aspect-ratio="1">
                            </v-img>
                          </a>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <a href="https://www.facebook.com/gamegawinp">
                            <v-img
                              :src="require('@/assets/FWlogo.gif')"
                              :lazy-src="require('@/assets/FWlogo.gif')"
                              max-height="120"
                              max-width="120"
                              contain
                              aspect-ratio="1">
                            </v-img>
                          </a>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>

            </v-flex>

            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div style="font-size:26px">ที่อยู่</div>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="font-size:16px">
                  <v-layout row justify-center>
                    <v-flex xs12 offset-xs2>
                      <p>บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด</p>
                      <v-spacer></v-spacer>
                      <p>22/6 หมู่ 1  ตำบลดอนลาน อำเภอผักไห</p>
                      <v-spacer></v-spacer>
                      <p>จังหวัดพระนครศรีอยุธยา 13280</p>
                      <v-spacer></v-spacer>
                      <p>ประเทศไทย</p>
                    </v-flex>
                  </v-layout>

                </v-card-text>
                <!-- <v-card-text>
                  <v-layout row wrap justify-center align-center fill-height>
                    <v-flex xs6>
                      <v-btn class="mx-1" dark icon>
                        <v-icon color="light-green accent-3" dark size="50px">fab fa-line</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs6>
                      <v-btn class="mx-1" dark icon>
                        <v-icon size="50px">fas fa-qrcode</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-img
                    :src="require('@/assets/line_add.jpg')"
                    :lazy-src="require('@/assets/line_add.jpg')"
                    aspect-ratio="2"
                    contain>
                  </v-img>
                </v-card-text> -->
              </v-card>
            </v-flex>

            <v-flex xs12 sm5>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div style="font-size:26px">ติดต่อ</div>
                </v-card-title>
                <v-divider></v-divider>
                <v-list class="transparent">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title><a href="tel:035-795-113" class="white--text">035-795-113</a>, <a href="tel:081-763-2077" class="white--text">081-763-2077</a></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">place</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>จังหวัดพระนครศรีอยุธยา, ประเทศไทย</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon class="blue--text text--lighten-2">email</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>kawin@naicsfurnishing.com</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <v-flex xs12>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15454.803041507808!2d100.274491!3d14.444401!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x654711012df04431!2sNaics+Furnishing+Co.%2C+Ltd.!5e0!3m2!1sen!2sth!4v1540396868501"
                    width="400" height="200" frameborder="0" style="border:0" allowfullscreen></iframe>
                </v-flex>
              </v-card>
            </v-flex>

          </v-layout>
        </v-container>
      </v-flex>

      <v-flex xs12>
        <v-flex xs12>
          <v-divider></v-divider>
        </v-flex>
        <v-card class="elevation-0 transparent">
          <v-card-text class="text-xs-center white--text">
            &copy;2018 — <strong>บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด (Naics Furnishing Co., Ltd.)</strong>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      'fab fa-facebook',
      'fab fa-twitter',
      'fab fa-google-plus',
      'fab fa-linkedin',
      'fab fa-instagram'
    ]
  })
}
</script>



// WEBPACK FOOTER //
// src/components/extra/footer.vue